import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { Input, Select, Checkbox } from 'antd';
import { Button, Table, Label } from 'semantic-ui-react';
import cx from 'classnames';
import { uniq } from 'lodash';

import {
  TableEmptyMessage,
  TableFooterPagination,
  TableHeader,
} from '../../shared/table';
import AddEditStore from './store';

const avatarPlaceholder = '';

@observer
class RegisteredSpecialists extends React.Component {
  state = {
    checkedAll: !!AddEditStore.registeredSpecialistIds.length,
  };

  detectIsNumeric = numberStr => {
    if (typeof numberStr != 'string') return false;
    return !isNaN(numberStr) && !isNaN(parseFloat(numberStr));
  };

  handleFilterSelectedDoctor = doctor => {
    const { searchSpecialist } = AddEditStore;
    if (searchSpecialist) {
      const fullname = doctor.FullName.toUpperCase();
      if (this.detectIsNumeric(searchSpecialist)) {
        if (
          fullname.search(searchSpecialist.toUpperCase()) !== -1 ||
          doctor.Id.toString().search(searchSpecialist) !== -1
        ) {
          return doctor;
        }
        return null;
      } else {
        if (fullname.search(searchSpecialist.toUpperCase()) !== -1) {
          return doctor;
        }
        return null;
      }
    } else {
      return doctor;
    }
  };

  renderTableBody = () => {
    if (AddEditStore.selectedSpecialist === 'selected') {
      return AddEditStore.specialists
        .filter(i => this.handleFilterSelectedDoctor(i))
        .map(record => (
          <Table.Row key={record.Id}>
            <Table.Cell>
              <Checkbox
                checked={this.isSpecialSelected(record.Id)}
                onChange={this.handleCheckSpecialist(record.Id)}
              />
            </Table.Cell>
            <Table.Cell className="Cell-nowrap doctor-info">
              <div
                className="avatar"
                style={{
                  background: `url(${record.Avartar || avatarPlaceholder})`,
                }}
              />
              <div className="doctor-name">
                {record.Title} {record.FullName}
              </div>
            </Table.Cell>
            <Table.Cell>
              {record.Specialty &&
                record.Specialty.split(', ').map(tag => (
                  <Label className="label-tag" key={tag}>
                    {tag}
                  </Label>
                ))}
            </Table.Cell>
            {/* <Table.Cell>{record?.ClientType || null}</Table.Cell> */}
          </Table.Row>
        ));
    }
    return AddEditStore.specialists.map(record => (
      <Table.Row key={record.Id}>
        <Table.Cell>
          <Checkbox
            checked={this.isSpecialSelected(record.Id)}
            onChange={this.handleCheckSpecialist(record.Id)}
          />
        </Table.Cell>
        <Table.Cell className="Cell-nowrap doctor-info">
          <div
            className="avatar"
            style={{
              background: `url(${record.Avartar || avatarPlaceholder})`,
            }}
          />
          <div className="doctor-name">
            {record.Title} {record.FullName}
          </div>
        </Table.Cell>
        <Table.Cell>
          {record.Specialty &&
            record.Specialty.split(', ').map(tag => (
              <Label className="label-tag" key={tag}>
                {tag}
              </Label>
            ))}
        </Table.Cell>
        <Table.Cell>{record?.ClientType || null}</Table.Cell>
      </Table.Row>
    ));
  };

  isSpecialSelected = id => {
    return !!AddEditStore.registeredSpecialistIds.find(sId => sId === id);
  };

  handleCheckAllSpecialist = ({ target: { checked } }) => {
    this.setState(
      { checkedAll: checked },
      action(() => {
        if (checked) {
          AddEditStore.registeredSpecialistIds = uniq([
            ...AddEditStore.registeredSpecialistIds,
            ...AddEditStore.specialists.map(s => s.Id),
          ]);
        } else {
          AddEditStore.registeredSpecialistIds = AddEditStore.registeredSpecialistIds.reduce(
            (acc, id) => {
              const index = AddEditStore.specialists.findIndex(
                s => s.Id === id,
              );
              if (index === -1) acc.push(id);
              return acc;
            },
            [],
          );
        }
      }),
    );
  };

  handleCheckSpecialist = id =>
    action(({ target: { checked } }) => {
      if (checked) {
        AddEditStore.registeredSpecialistIds = [
          ...AddEditStore.registeredSpecialistIds,
          id,
        ];
      } else {
        AddEditStore.registeredSpecialistIds = AddEditStore.registeredSpecialistIds.filter(
          sId => sId !== id,
        );
      }
    });

  render() {
    const columns = [
      {
        title: (
          <Checkbox
            checked={this.state.checkedAll}
            onChange={this.handleCheckAllSpecialist}
          />
        ),
      },
      { title: 'Specialist' },
      { title: 'Specialty' },
      // { title: 'Service Type' },
    ];

    return (
      <div className={cx({ disabled: AddEditStore.specialistLoading })}>
        <div className="registered-specialists-searchbox">
          <Input.Search
            placeholder="Search"
            size="large"
            value={AddEditStore.searchSpecialist}
            onChange={AddEditStore.handleSearchChange}
          />
          <Select
            style={{ marginTop: '10px', marginRight: '5px' }}
            size="large"
            value={AddEditStore.selectedSpecialist}
            onChange={AddEditStore.handleSelectChangeSpecialist}
          >
            <Select.Option value="All">Show all specialists</Select.Option>
            {AddEditStore.clientInfo.Id !== 0 && (
              <Select.Option value="selected">
                Show registered specialists
              </Select.Option>
            )}
          </Select>
          <Button positive onClick={AddEditStore.handleSearchSpecialist}>
            Search
          </Button>
          <Button negative onClick={AddEditStore.handleClearSearchSpecialist}>
            Clear
          </Button>
        </div>
        <Table sortable striped celled>
          <TableHeader columns={columns} />
          <Table.Body>
            {AddEditStore.specialists.length ? (
              this.renderTableBody()
            ) : (
              <TableEmptyMessage colSpan={columns.length} />
            )}
          </Table.Body>
          <TableFooterPagination
            colSpan={columns.length}
            totalItems={AddEditStore.sumItemSpecialist}
            currentPage={AddEditStore.curPageSpecialist}
            totalPage={AddEditStore.sumPageSpecialist}
            onPageClick={AddEditStore.handlePageClickSpecialist}
          />
        </Table>
      </div>
    );
  }
}

export default RegisteredSpecialists;
